import { createIcon } from '@chakra-ui/react';

export const UpiIcon = createIcon({
  displayName: 'UpiIcon',
  viewBox: '0 0 24 24',
  path: (
    <>
      <path fill='currentColor' d='M5 2l7 10-7 10 2-10z' />
      <path fill='currentColor' d='M11 2l7 10-7 10 2-10z' />
    </>
  ),
});
